import services from 'services/services';

// Import types
import type { TransactionDetails, LastPaymentsResponse } from 'types/api/payments';

export const fetchLastPaymentRedirectUrls = () =>
	services.get<LastPaymentsResponse>('/payments/last/redirect-urls').then((response) => response.data.data);

export const fetchLastProductPayment = async (uuid: string) =>
	services.get<TransactionDetails>(`/payments/payment/last/${uuid}`).then((response) => response.data);
